module.exports = __webpack_public_path__ + "media/images/plus-circle-e899fcad8567497c8b736e420d41c613.svg";